module.exports = __webpack_public_path__ + "/static/assets/31446edc97ac1eb0c3d2af65c0d8432a.svg";